export const prettifyPrice = price =>
  price && `${Number.isInteger(price) ? price : price.toFixed(2)}`;

export const prettifyThePriceWithZero = price => {
  if (price === null || price === undefined) return null;
  if (price === 0) return `$0`;
  return `$${Number.isInteger(price) ? price : price.toFixed(2)}`;
};
